import type { FreelancerResetPasswordLocales } from '../types';

const freelancerResetPasswordLocales: FreelancerResetPasswordLocales = {
  enterNewPassword:
    'Enter your new password here. Make sure you remember it this time ;)',
  passwordForgotten: 'Password Forgotten',
  repeatPassword: 'Repeat password',
  resetPassword: 'Reset password',
  title: 'Reset Password',
};

export default freelancerResetPasswordLocales;
